module.exports = __webpack_public_path__ + "c8b396c78cf82c372aee3e7dde4ce539.svg";